/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2025 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

// This map falls back to available regions the navigator language is not supported
const baseLocaleMap = {
  en: "en",
  it: "it",
  pt: "pt-BR",
  fr: "fr-FR",
  de: "de-DE",
  es: "es-ES",
  hi: "hi-IN",
  id: "id-ID",
  fil: "ph-PH",
  ph: "ph-PH",
  tr: "tr-TR",
  bn: "bn-IN",
  "en-US": "en",
  "pt-BR": "pt-BR",
  "fr-FR": "fr-FR",
  "de-DE": "de-DE",
  "it-IT": "it",
  "es-ES": "es-ES",
  "hi-IN": "hi-IN",
  "id-ID": "id-ID",
  "fil-PH": "ph-PH",
  "ph-PH": "ph-PH",
  "tr-TR": "tr-TR",
  "bn-IN": "bn-IN",
};

// QA languages to add for non-production environments only
const qaLocales: { [key: string]: string } = {
  "en-ZA": "en-ZA", // testing only, never to be in production
  // Below to be moved to the baseLocaleMap once they are ready for production
};

export const localeJsonPathMap: { [key: string]: string } = {
  en: "en",
  it: "it",
  "pt-BR": "pt-BR",
  "fr-FR": "fr-FR",
  "de-DE": "de-DE",
  "es-ES": "es-ES",
  "en-ZA": "en-ZA",
  "hi-IN": "hi-IN",
  "id-ID": "id",
  "tr-TR": "tr",
  "bn-IN": "bn",
  // There are no library supported json files for this language so we are handling it ourselves
  "ph-PH": "ph-PH",
};

// QA_LANGUAGE_ENABLED is used to enable the QA language in the language picker STAGE ONLY
export const localeMap: Record<string, string> = {
  ...baseLocaleMap,
  ...(process.env.QA_LANGUAGE_ENABLED === "true" ? qaLocales : {}),
};

const baseLocaleShorthands: Record<keyof typeof baseLocaleMap, string> = {
  bn: "bn",
  "bn-IN": "bn",
  de: "de",
  "de-DE": "de",
  en: "en",
  "en-US": "en",
  es: "es",
  "es-ES": "es",
  fr: "fr",
  "fr-FR": "fr",
  hi: "hi",
  "hi-IN": "hi",
  id: "id",
  "id-ID": "id",
  it: "it",
  "it-IT": "it",
  ph: "fil",
  fil: "fil",
  "fil-PH": "fil",
  "ph-PH": "fil",
  pt: "pt",
  "pt-BR": "pt",
  tr: "tr",
  "tr-TR": "tr",
};

export const localeShorthands: Record<string, string> = {
  ...baseLocaleShorthands,
  ...(process.env.QA_LANGUAGE_ENABLED === "true" ? qaLocales : {}),
};
